import React from 'react';
import { Box, Tooltip } from '@mui/material';

const SOURCE_META = {
  gm: {
    label: 'GM',
    title: 'GM file',
    color: '#64b5f6',
    bg: 'rgba(33, 150, 243, 0.14)',
    border: 'rgba(100, 181, 246, 0.62)',
  },
  cpq: {
    label: 'CPQ',
    title: 'CPQ file',
    color: '#b388ff',
    bg: 'rgba(126, 87, 194, 0.16)',
    border: 'rgba(179, 136, 255, 0.62)',
  },
  audit: {
    label: 'AUD',
    title: 'Audit only',
    color: 'text.secondary',
    bg: 'rgba(255, 255, 255, 0.06)',
    border: 'rgba(255, 255, 255, 0.24)',
  },
};

const SourceRoundBadge = ({ source, tooltipTitle = null }) => {
  const meta = SOURCE_META[source] || SOURCE_META.audit;
  return (
    <Tooltip title={tooltipTitle || meta.title}>
      <Box
        aria-label={`Source: ${meta.title}`}
        role="img"
        sx={{
          alignItems: 'center',
          bgcolor: meta.bg,
          border: '1px solid',
          borderColor: meta.border,
          borderRadius: '50%',
          color: meta.color,
          display: 'inline-flex',
          fontSize: meta.label.length > 2 ? 8.5 : 10,
          fontWeight: 900,
          height: 22,
          justifyContent: 'center',
          letterSpacing: 0,
          lineHeight: 1,
          minWidth: 22,
          width: 22,
        }}
      >
        {meta.label}
      </Box>
    </Tooltip>
  );
};

export default SourceRoundBadge;
